import {Button} from '@bitstillery/common/components'
import {classes} from '@bitstillery/common/lib/utils'
import {MithrilComponent} from '@bitstillery/mithril'
import {state} from '@bitstillery/mithril'
import m from '@bitstillery/mithril'

export interface CarouselSlide {
    description?: string
    link?: string
    title?: string | undefined
    url: string
}

interface CarouselAttrs {
    className: string
    current?: number | undefined
    indicators?: boolean
    item?: ((slide: CarouselSlide, active: boolean, index: number) => m.Vnode) | undefined
    mode?: string
    onchange: (index: number) => void
    onclose?: () => void
    slides: CarouselSlide[]
    type: string
}

interface ShowCarouselAttrs {
    className?: string
    controls?: boolean
    current?: number
    indicators?: boolean
    item?: (slide: CarouselSlide, active: boolean, index: number) => m.Vnode
    onchange?: (index: number) => void
    slides: CarouselSlide[]
    type?: string
}

/** Remove insert location and recreate the insert location. **/
function remove_element_from_dom() {
    const element = document.querySelector('#carousel-mount')
    const parent = element?.parentElement
    const new_element = document.createElement('div')
    new_element.id = 'carousel-mount'
    element?.remove()
    parent?.append(new_element)
}

export function mount_carousel(attrs: ShowCarouselAttrs) {
    let element = document.querySelector('#carousel-mount')
    if (!element) {
        element = document.createElement('div')
        element.id = 'carousel-mount'
        document.body.append(element)
    }

    m.mount(element, {
        view: () => (
            <Carousel
                className={attrs.className || ''}
                current={attrs.current}
                item={attrs.item}
                onchange={(index: number) => {
                    if (attrs.onchange) {
                        attrs.onchange(index)
                    }
                }}
                onclose={() => {
                    remove_element_from_dom()
                }}
                slides={attrs.slides}
                type={attrs.type || 'fullscreen'}
            />
        ),
    })

    return {
        close: () => {
            remove_element_from_dom()
        },
    }
}

export class Carousel extends MithrilComponent<CarouselAttrs> {
    data = state(
        {
            current: 0,
            initialized: false,
        },
        'carousel-data',
    )

    view(vnode: m.Vnode<CarouselAttrs>) {
        if (!this.data.initialized && typeof vnode.attrs.current === 'number') {
            this.data.current = vnode.attrs.current
            this.data.initialized = true
        }
        return (
            <div className={classes('c-carousel', vnode.attrs.className)}>
                <div
                    className={classes(vnode.attrs.type === 'inline' ? 'inline' : 'fullscreen c-dialog')}
                    onclick={() => {
                        if (vnode.attrs.onclose) {
                            vnode.attrs.onclose()
                        }
                    }}
                >
                    <div
                        className='detail-view'
                        onclick={(e: MouseEvent) => {
                            e.stopPropagation()
                        }}
                    >
                        {vnode.attrs.slides.length > 1 && (
                            <ol className='c-carousel-indicators'>
                                {vnode.attrs.slides.map((_slide, index) => (
                                    <li
                                        className={classes({active: index === this.data.current})}
                                        onclick={(e: MouseEvent) => {
                                            e.stopPropagation()
                                            this.data.current = index
                                            vnode.attrs.onchange(this.data.current)
                                        }}
                                    />
                                ))}
                            </ol>
                        )}

                        <div className='c-carousel-slides'>
                            {vnode.attrs.slides.map((slide, index) => {
                                if (vnode.attrs.item) {
                                    return vnode.attrs.item(slide, index === this.data.current, index)
                                }

                                return (
                                    <div className={classes('item', {active: index === this.data.current})}>
                                        <img src={slide.url} />
                                    </div>
                                )
                            })}

                            {vnode.attrs.slides.length > 1 && (
                                <div className='c-carousel-controls'>
                                    <Button
                                        className='left'
                                        icon='chevronLeft'
                                        onclick={(e) => {
                                            e.stopPropagation()
                                            if (this.data.current > 0) {
                                                this.data.current -= 1
                                            } else {
                                                this.data.current = vnode.attrs.slides.length - 1
                                            }

                                            vnode.attrs.onchange(this.data.current)
                                        }}
                                        type='brand'
                                        variant='toggle'
                                    />

                                    <Button
                                        className='right'
                                        icon='chevronRight'
                                        onclick={(e: Event) => {
                                            e.stopPropagation()
                                            if (this.data.current < vnode.attrs.slides.length - 1) {
                                                this.data.current += 1
                                            } else {
                                                this.data.current = 0
                                            }
                                            vnode.attrs.onchange(this.data.current)
                                        }}
                                        type='brand'
                                        variant='toggle'
                                    />
                                </div>
                            )}
                        </div>

                        {vnode.attrs.type !== 'inline' && (
                            <Button
                                className='btn-close'
                                onclick={() => {
                                    if (vnode.attrs.onclose) {
                                        vnode.attrs.onclose()
                                    }
                                }}
                                icon='close'
                                type='brand'
                                variant='toggle'
                            />
                        )}
                    </div>
                </div>
            </div>
        )
    }
}
